import { useEffect, useState } from "react";
import { useKYCContext } from "@/features/auth/hooks/use-kyc-context";
import { useOrigin } from "@/features/flow/hooks/use-origin";
import { FromURL } from "@/features/flow/types";
import { KYCSessionScenario, KYCStatusType } from "@/features/kyc/types";
import { identityPartners } from "@/features/user/types";
import { ModalKYCIdentity } from "@/molecules/modal-kyc-identity/index.react";
import { ModalIbanUniqAccount } from "@/molecules/modal-uniq-scenario/index.react";

export const ForcedKYCIdentityModal = ({
  identityPartners,
  bannerCreateAccountUrl
}: {
  identityPartners: identityPartners | null;
  bannerCreateAccountUrl?: string;
}) => {
  const { status, auditPending, kycLevel } = useKYCContext();
  const [open, setOpen] = useState<boolean>();
  const origin = useOrigin();

  useEffect(() => {
    if (!status) return;
    if (open === undefined && (kycLevel as number) < 2 && !auditPending) {
      setOpen(status === KYCStatusType.DECLARATIVE);
    }
  }, [status, auditPending, kycLevel]);

  return origin === FromURL.Partner &&
    identityPartners?.custom_scenario === KYCSessionScenario.Fusion ? (
    <ModalIbanUniqAccount
      bannerCreateAccountUrl={bannerCreateAccountUrl}
      isOpen={open as boolean}
      onClose={() => setOpen(false)}
    />
  ) : (
    <ModalKYCIdentity
      open={open}
      custom_scenario={false}
      onClose={() => {
        sessionStorage.removeItem("DocumentKsyc");
        setOpen(false);
      }}
    />
  );
};
